// extracted by mini-css-extract-plugin
export default {"highlight":"InsuranceLayout_highlight__yrV-L"};